import { render, staticRenderFns } from "./QuestionAnswerBlock.vue?vue&type=template&id=7a1f3fab&scoped=true&"
var script = {}
import style0 from "./QuestionAnswerBlock.vue?vue&type=style&index=0&id=7a1f3fab&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1f3fab",
  null
  
)

export default component.exports